angular.module('core').filter('students', [ 'numberFilter',
	function($numberFilter) {
		return function(input) {
			if(_.isUndefined(input) || !_.isNumber(input)) {
				return '';
			}
			else {
				if (input === 1) {
					return input + ' student';
				} else {
					return $numberFilter(input) + ' students';
				}
			}
		};
	}
]);
